/**
 * True when `url` targets this product's API: `<apiBaseUrl>/api/...` or, with no base
 * configured, a same-origin `/api/...` path. Interceptors use it so credentials, the CSRF
 * token and the correlation id are never attached to a request for a third party.
 */
export function isApiRequest(url: string, apiBaseUrl: string): boolean {
  if (url.startsWith('/api/')) return apiBaseUrl === '' || apiBaseUrl.startsWith('/');
  return apiBaseUrl !== '' && url.startsWith(`${apiBaseUrl}/api/`);
}

/** Auth endpoints that must never trigger a refresh and retry: they are the refresh itself. */
const AUTH_ENDPOINT = /\/api\/v\d+\/auth\/(sign-in|refresh|sign-out)/;

export function isAuthEndpoint(url: string): boolean {
  return AUTH_ENDPOINT.test(url);
}
